import React, { useState, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import Truncate from 'react-truncate-markup';
import Markdown from 'markdown-to-jsx';
import MentionHighlightTag from '../../../core/components/MentionHighlightTag';
import { formatMentionChunks } from '../../../core/components/ChunkHighlighter';
import { CommentContent, ReadMoreButton } from './styles';
import { defaultBlockComponentMap, defaultMarkComponentMap, } from '../../../core/components/RichTextEditor';
const COMMENT_MAX_LINES = 8;
const CommentText = ({ text, className, mentionees, maxLines = COMMENT_MAX_LINES, isOldStyle }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const expand = () => setIsExpanded(true);
    const textWithMentions = useMemo(() => formatMentionChunks(text, mentionees, 'mention'), [text, mentionees]);
    const renderOverrides = useMemo(() => (Object.assign(Object.assign(Object.assign({}, defaultBlockComponentMap), defaultMarkComponentMap), { mention: {
            component: MentionHighlightTag,
            props: {
                mentionees,
            },
        } })), [mentionees]);
    const textContent = text && (React.createElement(CommentContent, { className: className, "data-qa-anchor": "comment-content", isOldStyle: isOldStyle },
        React.createElement(Markdown, { options: {
                overrides: renderOverrides,
            } }, textWithMentions)));
    if (isExpanded)
        return textContent;
    return (React.createElement(Truncate.Atom, { lines: maxLines, ellipsis: React.createElement(ReadMoreButton, { onClick: expand },
            React.createElement(FormattedMessage, { id: "comment.readmore" })) }, textContent));
};
export default CommentText;
//# sourceMappingURL=CommentText.js.map